import React, { useEffect, useState, FC } from 'react';
import _ from 'lodash';

//Components
import { Button, Table } from 'react-bootstrap';

//Icons
import { FaTrash } from 'react-icons/fa';

//Types
import { TableColumnInterface, TableOptionsInterface } from './Types';

//Styles
import './styles.scss';

interface ActivitySelectTableInterface {
    available: any;
    selected: any;
    columns: Array<TableColumnInterface>;
    options: TableOptionsInterface;
    onSave: Function;
}

interface SearchListInterface {
    elements: Array<any>;
    searchResultFormat?: Function;
    handleSave: Function;
}

const SearchList: FC<SearchListInterface> = (props: SearchListInterface) => {
    const { elements, searchResultFormat, handleSave } = props;

    return (
        <ul className="select-table-search-list">
            {elements.map((ele, idx) =>
                <li key={idx} className="select-table-search-list-item" onClick={() => handleSave(ele)}>
                    {searchResultFormat ?
                        searchResultFormat(ele) :
                        ele.name
                    }
                </li>
            )}
        </ul>
    )
}

const ActivitySelectTable: FC<ActivitySelectTableInterface> = (props: ActivitySelectTableInterface) => {
    const { available, selected, columns, options, onSave } = props;

    const [search, setSearch] = useState("");
    const [searchResult, setSearchResult] = useState([false]);
    const [searchOpen, setSearchOpen] = useState(false);

    useEffect(() => {
        const result = available.filter((ele: any) =>
            options.searchBy?.some(attribute => ele[attribute].toLowerCase().includes(search.toLowerCase()))
        );

        setSearchResult(result)
    }, [search, available, options]);

    const handleSearch = _.debounce((searchValue: string) => {
        setSearch(searchValue)
        setSearchOpen(true)
    }, 300);

    const closeSearch = _.debounce(() => {
        setSearchOpen(false)
    }, 200);

    const handleSave = (row: any) => {
        //Add to selected
        const newSelected = [...selected];
        newSelected.push(row);

        //Remove from available
        const newAvailable = available.filter((sel: any) => sel.id !== row.id);

        onSave({ selected: newSelected, available: newAvailable });
        setSearchOpen(false);
        setSearch("");
    }

    const handleDelete = (row: any) => {
        //Remove from selected
        const newSelected = selected.filter((sel: any) => sel.id !== row.id);

        //Add to available
        const newAvailable = [...available];
        newAvailable.push(row);

        onSave({ selected: newSelected, available: newAvailable })
    }

    return (
        <div>
            <input
                className="select-table-search-field"
                placeholder="Buscar"
                onChange={(e) => handleSearch(e.target.value)}
                onFocus={(e) => handleSearch(search)}
                onBlur={() => closeSearch()}
            ></input>
            {search && searchOpen &&
                <SearchList
                    elements={searchResult}
                    searchResultFormat={options.searchResultFormat}
                    handleSave={handleSave}
                />}
            <div style={{ maxHeight: options?.height, overflowY: options?.height ? "auto" : "unset" }}>
                <Table bordered>
                    <thead>
                        <tr>
                            {columns.map((column) => (
                                <th key={column.value}>
                                    {column.title ? column.title : ''}
                                </th>
                            ))}
                            <th />
                        </tr>
                    </thead>
                    <tbody>
                        {selected.map((row: any, rowKey: any) =>
                            <tr key={`row-${rowKey}`}>
                                {columns.map((column, columnKey) => (
                                    <td key={`${column.value}-${columnKey}`}>
                                        {row[column.value]}
                                    </td>
                                ))}
                                <td className="buttons-container-center" >
                                    <Button className='paginator-button' size="sm" onClick={() => handleDelete(row)}>
                                        <FaTrash />
                                    </Button>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>
        </div >
    )
};

export default ActivitySelectTable;
